<div class="ro-activities position-relative mb-4 pb-4">
  <div class="activity-divider"></div>
  <div class="activity-circle"></div>

  <div *ngFor="let activityGroup of _activities">
    <div class="ativity-date-wrapper">
      <p class="activity-date flex-center-center font-secondary-700 font-600">
        <i class="far fa-calendar-day pr-2"></i>
        <span>{{activityGroup?.date}}</span>
      </p>
    </div>

    <div class="activity-list-wrapper">
      <app-ro-activity *ngFor="let activity of activityGroup.activities" [activity]="activity" [invCode]="invCode" [code]="code"
        (openCustomerInSidepanel)="openCustomerInSidepanel($event)"
        (openVehicleInSidepanel)="openVehicleInSidepanel($event)"
        (openAttachmentTab)="handleOpenAttachmentTab($event)"></app-ro-activity>
    </div>
  </div>
</div>
